<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="900" scrollable>
			<v-card>
				<v-card-title class="headline">
					<span>Detail Transaksi</span>
					<span class="pl-2 font-weight-bold">{{ detailTransaction.trx_code }}</span>
				</v-card-title>
				<v-card-text class="black--text">
					<v-row class="mb-3">
						<v-col cols="6" md="6">
							<div class="text-subtitle-1 font-weight-bold">
								<v-icon color="primary">mdi-card-account-details</v-icon>
								<span class="ml-2">Detail Stockist</span>
							</div>
							<div class="pt-1">
								<span>{{detailTransaction.stockist_name}}</span>
								<span v-if="detailTransaction.stockist_code"> - {{detailTransaction.stockist_code}}</span>
								<span v-if="detailTransaction.stockist_network_mid"> - {{detailTransaction.stockist_network_mid}}</span>
							</div>
							<div class="pt-1">{{detailTransaction.stockist_mobilephone}}</div>
							<div class="pt-1">{{addressText(detailTransaction)}}</div>

							<div class="text-subtitle-1 font-weight-bold mt-1">
								<v-icon color="primary">mdi-account</v-icon>
								<span class="ml-2">Detail Pembeli</span>
							</div>
							<div class="pt-1">
								<span>{{detailTransaction.trx_buyer_name}}</span>
								<span v-if="detailTransaction.trx_buyer_mobilephone"> ({{detailTransaction.trx_buyer_mobilephone}})</span>
							</div>
							<div class="pt-1"></div>
							<div class="pt-1">{{detailTransaction.trx_buyer_email}}</div>

							<div class="text-subtitle-1 font-weight-bold mt-1">
								<v-icon color="primary">mdi-truck</v-icon>
								<span class="ml-2">Detail Pengiriman</span>
							</div>
							<div class="pt-1" v-if="detailTransaction.trx_shipping_method == 0">
								<div>Pickup</div>
								<div>
									<span>{{detailTransaction.shipping_pickup.trx_shipping_pickup_plan_date | haritanggal}}</span>
								</div>
							</div>
							<div class="pt-1" v-else-if="detailTransaction.trx_shipping_method == 1">
								<div>Shipping Courier</div>
								<div>
									<span class="text-uppercase">{{detailTransaction.shipping_courier.trx_shipping_courier_name}}</span>
									<span> - {{detailTransaction.shipping_courier.trx_shipping_courier_service}}</span>
									<span> ({{detailTransaction.shipping_courier.trx_shipping_courier_price_total | toRupiah}}) </span>
								</div>
							</div>
							<div class="pt-1"></div>
						</v-col>
						<v-col cols="6" md="6">
							<div class="text-subtitle-1 font-weight-bold mt-1">
								<v-icon color="primary">mdi-format-list-checkbox</v-icon>
								<span class="ml-2">Detail Transaksi</span>
							</div>
							<tbody>
								<tr>
									<td style="width:50%">Kode Transaksi</td>
									<td> : </td>
									<td>{{ detailTransaction.trx_code }}</td>
								</tr>
								<tr>
									<td >Waktu Transaksi</td>
									<td> : </td>
									<td>{{ detailTransaction.trx_datetime | tanggalid }}</td>
								</tr>
								<tr>
									<td >Status Transaksi</td>
									<td> : </td>
									<td>{{ detailTransaction.trx_status_name }}</td>
								</tr>
								<tr>
									<td >Metode Pembayaran</td>
									<td> : </td>
									<td>{{ detailTransaction.trx_payment_method_text }}</td>
								</tr>
								<tr v-if="detailTransaction.trx_payment_method == '1'">
									<td >Bank Penerima</td>
									<td> : </td>
									<td>{{ detailTransaction.payment_bank.trx_payment_bank_to_bank_account_bank }} ({{ detailTransaction.payment_bank.trx_payment_bank_to_bank_account_no }})</td>
								</tr>
								<tr v-if="detailTransaction.trx_payment_method == '1'">
									<td >Nama Penerima</td>
									<td> : </td>
									<td>{{ detailTransaction.payment_bank.trx_payment_bank_to_bank_account_name }}</td>
								</tr>
								<tr v-if="detailTransaction.trx_payment_method == '1'">
									<td >Bank Pengirim</td>
									<td> : </td>
									<td>{{ detailTransaction.payment_bank.trx_payment_bank_from_bank_name }} ({{ detailTransaction.payment_bank.trx_payment_bank_from_bank_account_no }})</td>
								</tr>
								<tr v-if="detailTransaction.trx_payment_method == '1'">
									<td >Nama Pengirim</td>
									<td> : </td>
									<td>{{ detailTransaction.payment_bank.trx_payment_bank_from_bank_account_name }}</td>
								</tr>
								<tr v-if="detailTransaction.trx_payment_method == '1'">
									<td >Jumlah Transfer</td>
									<td> : </td>
									<td>{{ detailTransaction.payment_bank.trx_payment_bank_transfer_value | toRupiah }}</td>
								</tr>
								<tr v-if="detailTransaction.trx_payment_method == '2'">
									<td >Bank VA</td>
									<td> : </td>
									<td>{{ detailTransaction.payment_va.trx_payment_va_bank }}</td>
								</tr>
								<tr v-if="detailTransaction.trx_payment_method == '2'">
									<td >Nomor Tagihan VA</td>
									<td> : </td>
									<td>{{ detailTransaction.payment_va.trx_payment_va_number }}</td>
								</tr>
								<tr v-if="detailTransaction.trx_payment_method == '2'">
									<td >Tanggal Kadaluwarsa VA</td>
									<td> : </td>
									<td>{{ detailTransaction.payment_va.trx_payment_va_expired_datetime | tanggalid }}</td>
								</tr>
								<tr v-if="detailTransaction.trx_payment_method == '2'">
									<td >Tanggal Proses VA</td>
									<td> : </td>
									<td>{{ detailTransaction.payment_va.trx_payment_va_process_datetime | tanggalid }}</td>
								</tr>
							</tbody>
						</v-col>
					</v-row>
					<v-list color="deep-purple lighten-5" class="pa-1 mb-3" rounded>
						<v-list-item dense class="px-1 justify-center">
							<div class="font-weight-bold text-uppercase primary--text">detail produk</div>
						</v-list-item>
					</v-list>
					<v-card class="mb-5 elevation-0">
						<v-data-table :headers="headers" :items="detailTransaction.product" hide-default-footer>
							<template v-slot:item.quantity="{ item }">
								<div>{{ item.quantity | toNumber }} {{ item.unit }}</div>
							</template>
							<template v-slot:item.price_base="{ item }">
								<div>{{ item.price_base | toRupiah }}</div>
							</template>
							<template v-slot:item.price_total="{ item }">
								<div>{{ item.price_total | toRupiah }}</div>
							</template>
						</v-data-table>
					</v-card>
					<v-list color="deep-purple lighten-5" class="pa-1 mb-3" rounded>
						<v-list-item dense class="px-1 justify-center">
							<div class="font-weight-bold text-uppercase primary--text">status pemesanan</div>
						</v-list-item>
					</v-list>
					<v-row class="mb-3" v-for="(trx_status, index) in detailTransaction.trx_status" :key="index">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailTransaction.trx_status_name == trx_status.trx_status_name ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{trx_status.trx_status_name}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{trx_status.trx_status_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideDialog">Tutup</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			dialog: false,
			headers: [
			{ text: 'Nama Produk', value: 'name', sortable: false},
			{ text: 'Kode Produk', value: 'code', sortable: false},
			{ text: 'Jumlah', value: 'quantity', sortable: false, align: 'center' },
			{ text: 'Harga', value: 'price_base', sortable: false, align: 'center' },
			{ text: 'Total Harga', value: 'price_total', sortable: false, align: 'center' },
			],
			scheduleHeaders: [
			{ text: 'Nama Produk', value: 'product_name', sortable: false, width: '50%'},
			{ text: 'Kode Produk', value: 'product_code', sortable: false, width: '30%'},
			{ text: 'Jumlah', value: 'po_schedule_detail_quantity', sortable: false, align: 'center', width: '20%'},
			],
		}
	},
	computed:{
		...mapState('ecommerceTransaction', ['detailTransaction']),

		poSchedules() {
			let schedule = []
			if (this.detailTransaction.po_schedules) {
				schedule = this.detailTransaction.po_schedules.reduce((r, a) => {
					r[a.po_schedule_detail_date] = [...r[a.po_schedule_detail_date] || [], a];
					return r;
				}, {});
			}
			return schedule
		},
	},
	methods :{
		showModal(){
			this.dialog = true
		},
		hideDialog(){
			this.dialog = false
		},
		addressText(value) {
			var data = []
			if (value.stockist_origin_address)
				data.push(value.stockist_origin_address)
			if (value.stockist_origin_subdistrict_name)
				data.push(value.stockist_origin_subdistrict_name)
			if (value.stockist_origin_city_name)
				data.push(value.stockist_origin_city_name)
			if (value.stockist_origin_province_name)
				data.push(value.stockist_origin_province_name)
			return data.join(', ')
		}
	}
}
</script>